import { PaginationState } from '../pages/arc/shared-slices/pagination-model';

export interface ListItem {
	id: number | string;
}
export interface SampleItem extends ListItem {
	name: string;
	employmentType: string;
}
export interface FilterOption {
	filterKey: string,
	filterValue: string,
	filterDisplayValue?: string,
}

export interface Filter {
	filterKey: string,
	filterOptions: FilterOption[],
	partialMatch: boolean,
}
export interface Sort {
	prop: string,
	descending: boolean,
}
export interface SearchState {
	filters: { [key: string]: Filter },
	lists: ListItem[],
	listInitialized: boolean,
	currentLoading: boolean,
	sortBy: Sort,
	appName: string,
}


export enum SearchStateActions {
	INITIALIZE_LIST = 'INITIALIZE_LIST',
	UPDATE_FILTER = 'UPDATE_FILTER',
	START_INITIALIZE_LIST = 'START_INITIALIZE_LIST',
	COMPLETE_UPDATE = 'COMPLETE_UPDATE',
	CLEAR_FILTER = 'CLEAR_FILTER',
	SORT_LIST = 'SORT_LIST',
}

export interface SearchAppState {
	searchState: SearchState,
	paginationState: PaginationState,
}

export const All = 'All';
export const Empty = 'Empty';
